module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "500px",
      "override": "hidden"
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "450"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nah"
  }, [(_vm.npo) ? _c('tooltip', {
    attrs: {
      "title": _vm.npo.name,
      "description": " "
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40093a3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/clusters.vue
// module id = 51
// module chunks = 0